import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/navigation/Breadcrumb.css';

function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Route name mapping
  const routeNames = {
    'dashboard': 'Dashboard',
    'peopleplan': 'People Plan',
    'hr': 'HR',
    'requests': 'Requests',
    'ta': 'TA',
    'jobs': 'Jobs',
    'boost': 'Boost a Role',
    'referrals': 'Referrals',
    'candidates': 'Candidate Tracker',
    'newhires': 'New Hires',
    'ld': 'L&D',
    'checkins': 'Weekly Checkins',
    'files': 'Depository Files',
  };

  // Don't show breadcrumb on dashboard or login
  if (pathnames.length === 0 || (pathnames.length === 1 && pathnames[0] === 'dashboard')) {
    return null;
  }

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        <li className="breadcrumb-item">
          <Link to="/dashboard">Home</Link>
        </li>
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          const displayName = routeNames[name] || name.charAt(0).toUpperCase() + name.slice(1);

          return (
            <li key={name} className="breadcrumb-item">
              <span className="breadcrumb-separator">/</span>
              {isLast ? (
                <span className="breadcrumb-current" aria-current="page">
                  {displayName}
                </span>
              ) : (
                <Link to={routeTo}>{displayName}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumb;